export default "__VITE_ASSET__BumKyFt4__"